import { Button } from "../ui/button";
import { PiButterflyThin } from "react-icons/pi";
import { Header } from "./header";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
export const Hero = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    const media = window.matchMedia("(max-width: 1023px)");

    if (media.matches) {
      setMobile(true);
    } else {
      setMobile(false);
    }

    const handleResize = () => {
      if (media.matches) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
    window.addEventListener("orientationchange", handleResize);
    window.addEventListener("change", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      window.removeEventListener("change", handleResize);
    };
  }, []);

  return (
    <div id="inicio" className="flex h-full min-h-screen w-full flex-col">
      <div className="flex max-h-[95%] w-full flex-grow ld:items-center sm:justify-center bg-[#FFDCC5] ">
        <div className="w-full max-h-[80%] max-lg:mt-5 flex lg:justify-center ">
          <div className=" flex flex-col lg:flex-row flex sm:h-full w-full max-w-[1400px] p-5 gap-10  sm:items-center">
            <div
              id="hero-info"
              className=" flex flex-col gap-12 sm:max-h-full  sm:flex-grow items-center "
            >
              <div
                id="encabezado"
                className="leading-tight max-md:w-full flex text-[50px] 2xl:text-[120px] xl:text-[90px] md:text-[80px] font-extrabold gap-4 flex-wrap line-clamp-2 flex-shrink-0 justify-center"
              >
                <h1 className="text-subtle font-Lato select-none">
                  Bienvenido a
                  <span className="ml-4 flex w-full justify-center text-mariposa font-Dancing select-none">
                    La Mariposa
                  </span>
                </h1>
              </div>

              <h3 className="flex w-full justify-center text-center text-subtle font-Lato   md:text-[16px] xl:text-[20px] font-semibold ">
                Una experiencia culinaria tan única como el vuelo de una
                mariposa.
              </h3>

              <div className="hidden lg:flex w-full gap-20 flex-wrap justify-center ">
                <Button
                  className="bg-mariposa text-white px-6 py-4 text-[14px] font-bold font-Lato"
                  onClick={() => navigate("/menu")}
                >
                  {" "}
                  Ver menú{" "}
                </Button>
                <Button
                  className="bg-mariposa text-white px-6 py-4 text-[14px] font-bold font-Lato"
                  onClick={() =>
                    toast.info(
                      "Sistema de reservas en desarrollo. Espere proximas actualizaciones.",
                    )
                  }
                >
                  {" "}
                  Reserva ahora!{" "}
                </Button>
              </div>
            </div>

            <div className=" relative w-full max sm:max-w-[500px] xl:w-[50%] flex-grow max-md:max-h-[400px] max-h-full sm:max-h-[600px] max-h-[300px] sm:h-full flex items-center justify-center justify-self-end">
              <img
                src="/images/banner.webp"
                alt=""
                className="object-cover w-full h-full absolute top-0 left-0 contrast-[85%] saturate-[1.2] "
              />

              <img
                src={
                  mobile
                    ? "images/Icons/mariposa-background2.webp"
                    : "images/Icons/mariposa-background.webp"
                }
                alt="mariposa"
                className="h-full w-full z-10"
              ></img>
            </div>

            <div className="flex lg:hidden w-full gap-10 md:gap-20 flex-wrap justify-center">
              <Button
                className="bg-mariposa w-[150px] text-white px-6 py-4 text-[14px] font-bold font-Lato flex-grow max-w-[200px]"
                onClick={() => navigate("/menu")}
              >
                {" "}
                Ver menú{" "}
              </Button>
              <Button
                className="bg-mariposa w-[150px] text-white px-6 py-4 text-[14px] font-bold font-Lato flex-grow max-w-[200px]"
                onClick={() =>
                  toast.info(
                    "Sistema de reservas en desarrollo. Espere proximas actualizaciones.",
                  )
                }
              >
                {" "}
                Reserva ahora!{" "}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
